import Organization from '@/entities/organization';

class StorageItems {
  private siteInfo: StorageItemSiteInfo;
  private atcExtraHeader: string;
  private auditUserInfo: StorageItemAuditUserInfo;
  public getSiteInfo() : StorageItemSiteInfo {
    return this.siteInfo;
  }
  public getAtcExtraHeader() : string {
    return this.atcExtraHeader;
  }
  public setSiteInfo(siteInfo: StorageItemSiteInfo) : void {
    this.siteInfo = siteInfo;
  }
  public setAtcExtraHeader(atcExtraHeader: string) : void {
    this.atcExtraHeader = atcExtraHeader;
  }
  public getAuditUserInfo() : StorageItemAuditUserInfo {
    return this.auditUserInfo;
  }
  public setAuditUserInfo(auditUserInfo: StorageItemAuditUserInfo) : void {
    this.auditUserInfo = auditUserInfo;
  }
}

class StorageItemSiteInfo {
  languageCode: string;
  siteConfiguration: string;
  privateLabelInfo: PrivateLabelInfo;
}

class PrivateLabelInfo {
  id: number;
  name: string;
  phone?: number;
  email?: string;
  countryId?: number;
}
class GlobalPermissionIssue {
  alertTitle?: string;
  alertSubTitle?: string;
  issueType?: string;
  details?: string;
}

class StorageItemAuditUserInfo {
  loginName: string;
  auditUser: string;
  auditUserFirstName: string;
  auditUserLastName: string;
}

export {
  StorageItems,
  StorageItemSiteInfo,
  PrivateLabelInfo,
  GlobalPermissionIssue,
  StorageItemAuditUserInfo,
};
